import * as stylex from "@stylexjs/stylex";
import { colors } from "../consts.stylex";
export const linkBody = {
    root: {
        k63SB2: "x1xlr1w8",
        kMwMTN: "x12klvby",
        kDPRdz: "xhr9w20",
        $$css: true
    }
};
